import script from "./tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./tag.vue?vue&type=script&setup=true&lang=ts"

import "./tag.vue?vue&type=style&index=0&id=1d34a07e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d34a07e"]])

export default __exports__